import type creatorZh from '../zh/creator';

const creator: typeof creatorZh = {
  title: 'Creator management',
  tabs_label: 'Creator management tabs',
  tab_mine: 'My creators',
  tab_blacklist: 'Creator blacklist',
  tab_collab: 'Collaborating creators',
  tab_intent: 'Interested creators',
  mine_subtitle: 'Creators synced from square saves, invites, DMs, and email',
  blacklist_subtitle: 'Blocked creators are excluded from invites, DMs, and email',
  blacklist_hint:
    'Once added, they are removed from DMs, email, and targeted invites. Creators already on the list will not appear again.',
  collab_subtitle: 'Collaborated or in progress · view details and stats',
  collab_hint:
    'Includes active collaborations and creators with orders. Data comes from catalog fulfillment and the sales overview (limited).',
  intent_subtitle: 'Contacted with a reply, but not yet collaborating',
  intent_hint: 'Rule: has email or DMs, and is not yet a collaborating creator. The blacklist is hidden.',
  search_placeholder: 'Search creators / names',
  last_channel: 'Latest reply channel',
  channel_dm: 'DM',
  channel_email: 'Email',
  reply_counts: 'DMs {{dm}} · Emails {{email}}',
  batch_outreach: 'Bulk outreach',
  batch_invite: 'Batch invite',
  find_talent: 'Find creators',
  add_invite: 'Add to invite',
  send_dm: 'Send DM',
  send_email: 'Send email',
  mine_count: '{{count}} creators',
  load_failed: 'Failed to load my creators',
  intent_load_failed: 'Failed to load interested creators',
  collab_load_failed: 'Failed to load collaborating creators',
  col_source: 'Source',
  source_invite_accepted: 'Invite accepted',
  source_chat: 'Converted from chat',
  col_added_products: 'Products added',
  blacklist_load_failed: 'Failed to load blacklist',
  blacklist_current: 'On blacklist',
  blacklist_history: 'Removal history',
  removed_tag: 'Removed',
  tag_none: 'No tag',
  col_talent: 'Creator',
  col_tags: 'Tags',
  gmv30: '30-day GMV',
  followers: 'Followers',
  col_actions: 'Actions',
  tag_coop: 'Collab',
  tag_high_conv: 'High conversion',
  tag_intent: 'Interested',
  outreach: 'Outreach',
  unfavorite: 'Unsave',
  unfavorite_confirm: 'Remove {{name}} from saved creators?',
  unfavorite_success: 'Unsaved {{name}}',
  unfavorite_failed: 'Could not unsave this creator',
  add_blacklist: 'Add to blacklist',
  col_added_by: 'Added by',
  col_region: 'Region',
  col_added_at: 'Added at',
  col_reason: 'Reason',
  remove: 'Remove',
  remove_confirm: 'Remove {{name}} from the blacklist?',
  blacklist_removed: 'Removed from blacklist: {{name}}',
  blacklist_remove_failed: 'Could not remove from blacklist',
  blacklist_missing_remove_id: 'Missing influencer ID, cannot remove',
  col_status: 'Status',
  col_start: 'Collab start',
  col_shop: 'Store',
  col_product: 'Collab product',
  sales_gmv: 'Sales GMV',
  col_orders: 'Orders',
  sales_detail: 'Sales details',
  no_sales_data: 'No sales data',
  col_stage: 'Stage',
  col_channels: 'Channels',
  col_last_interaction: 'Last interaction',
  col_last_content: 'Latest content',
  col_reply: 'Replies',
  view_email: 'View email',
  email_thread: 'Email thread: {{name}}',
  convert_collab: 'Convert to collab',
  convert_confirm: 'Convert {{name}} into a collaborator of the current shop?',
  converted_collab: 'Converted to collab: {{name}}',
  convert_failed: 'Could not convert to a collaboration',
  reason_poor: 'Poor fulfillment',
  reason_timeout: 'Not shipped in time',
  reason_no_update: 'No response after follow-ups',
  reason_fraud: 'Fraud risk',
  reason_policy: 'Violation / complaint',
  reason_other: 'Other',
  remark: 'Note',
  select_talent_required: 'Please select a creator',
  blacklist_missing_id: 'Missing influencer ID, cannot block',
  blacklist_failed: 'Failed to add to blacklist',
  blacklist_added: 'Added to blacklist: {{talent}} ({{reason}})',
  select_talent: 'Select a creator',
  reason: 'Reason',
  join: 'Add',
  col_item: 'Product',
  col_coop_time: 'Collab period',
  col_showcase: 'Showcase',
  col_videos: 'Videos',
  col_live: 'Lives',
  commission: 'Commission',
  video_live: 'Videos / lives',
  ctr: 'CTR',
  collab_heading: '{{name}} · Collab details',
  collab_meta: '{{handle}} · {{shop}} · Started {{date}}',
  collab_detail: 'Collab details'
};

export default creator;
